import { useMemo } from "react";
import { useAppSelector } from "../store/hooks";
import { EmployeeDashboardAccess } from "../store/allocation/employeeDashboardSlice";
import {
  canEmployeeLoginOnPortal,
  canViewEmployeeOverviewAll,
} from "../utils/employeeRoles";

export function useEmployeeDashboardAccess() {
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.allocationAuth);

  return useMemo(() => {
    const portalRole = user?.role || "";
    const empRole = employee?.role || "";

    const portalAllowed = ["Production", "Operations", "Super Admin"].includes(portalRole);

    let employeeAllowed = false;
    if (portalRole === "Super Admin") {
      employeeAllowed = true;
    } else if (portalRole === "Production" || portalRole === "Operations") {
      employeeAllowed = canEmployeeLoginOnPortal(empRole, portalRole);
    }

    const canViewAll = canViewEmployeeOverviewAll(portalRole, empRole);

    const needsEmployeeLogin =
      portalRole === "Production" || portalRole === "Operations";

    const access: EmployeeDashboardAccess | null =
      portalAllowed && (portalRole === "Super Admin" || employeeAllowed)
        ? {
            portalRole,
            viewerEmpId: employee?.emp_id ?? null,
            viewerEmpRole: employee?.role ?? null,
            viewerEmpName: employee?.emp_name ?? null,
          }
        : null;

    return {
      portalAllowed,
      employeeAllowed,
      canViewAll,
      needsEmployeeLogin,
      access,
      employee,
      user,
    };
  }, [user, employee]);
}
